import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const NarrowArrowUpIcon = forwardRef<SVGSVGElement, IconProps>(function NarrowArrowUpIcon(
  { color = '', height = 18, width = 18, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox={'0 0 ' + width + ' ' + height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 3C9.14583 3 9.28569 3.05125 9.38881 3.14249L13.839 7.07979C14.0537 7.26977 14.0537 7.5778 13.839 7.76778C13.6242 7.95777 13.2761 7.95777 13.0613 7.76778L9.54985 4.66097V14.5135C9.54985 14.7822 9.30368 15 9 15C8.69632 15 8.45015 14.7822 8.45015 14.5135V4.66097L4.93866 7.76778C4.72393 7.95777 4.37578 7.95777 4.16105 7.76778C3.94632 7.5778 3.94632 7.26977 4.16105 7.07979L8.6112 3.14249C8.71431 3.05125 8.85417 3 9 3Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
});
